import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@boma/app-config';
import { IPaginatedResponse } from '@boma/client-shared';
import {
  IAddOrUpdateCatalogueItemLocation,
  ICatalogueItem,
  IProduct,
} from '@boma/supplier-portal/shared/entities';

@Injectable({
  providedIn: 'root',
})
export class CatalogueService {
  private base: string;
  private version: string;
  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  loadCatalogue(
    entityId: string,
    locationId: string = '',
    page: string = '1',
    perPage: string = '25',
    query: string = ''
  ) {
    return this.httpClient.get<IPaginatedResponse<ICatalogueItem>>(
      `${this.base}api/v${this.version}/${entityId}/Catalogue`,
      {
        params: { supplierId: entityId, locationId, page, perPage, query },
      }
    );
  }

  loadCatalogueProduct(entityId: string, productId: string) {
    return this.httpClient.get<ICatalogueItem>(
      `${this.base}api/v${this.version}/${entityId}/Catalogue/${productId}`
    );
  }

  addOrUpdateCatalogueProduct(
    entityId: string,
    productId: any,
    locations: IAddOrUpdateCatalogueItemLocation[]
  ) {
    return this.httpClient.post<ICatalogueItem>(
      `${this.base}api/v${this.version}/${entityId}/Catalogue/${productId}`,
      locations
    );
  }
  // TODO : Discusss if there is a difference between catalogue and products, seems pretty much interchangeable to me at this point.
  createProduct(
    name: string,
    description: string,
    categoryId: string,
    productTaxExempt: boolean,
    imageId: string = '',
    entityId: string
  ) {
    // TODO ADD A TYPE
    return this.httpClient.post(
      `${this.base}api/v${this.version}/${entityId}/Products/`,
      {
        params: {
          name,
          description,
          categoryId,
          productTaxExempt,
          imageId,
          entityId,
        },
      }
    );
  }
}
